// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5bd68712","952":"3b3a45dc"}[chunkId] + ".chunk.js";
};